/* 武將名冊：全部可選武將，順序就是選將畫面、電腦補位與錄影比對用的順序。
 * 要改某名武將：直接打開 heroes/<陣營>/<id>.ts（shu 蜀、wu 吳、wei 魏）。新增武將：建檔後加到下面的清單。 */
import { SG } from '../core/sg.ts';
import liubei from './shu/liubei.ts';
import guanyu from './shu/guanyu.ts';
import zhangfei from './shu/zhangfei.ts';
import zhaoyun from './shu/zhaoyun.ts';
import machao from './shu/machao.ts';
import huangzhong from './shu/huangzhong.ts';
import zhugeliang from './shu/zhugeliang.ts';
import pangtong from './shu/pangtong.ts';
import weiyan from './shu/weiyan.ts';
import jiangwei from './shu/jiangwei.ts';
import huangyueying from './shu/huangyueying.ts';
import madai from './shu/madai.ts';
import xushu from './shu/xushu.ts';
import mizhu from './shu/mizhu.ts';
import menghuo from './shu/menghuo.ts';
import zhurong from './shu/zhurong.ts';
import maliang from './shu/maliang.ts';
import fazheng from './shu/fazheng.ts';
import zhoucang from './shu/zhoucang.ts';
import chendao from './shu/chendao.ts';
import sunquan from './wu/sunquan.ts';
import sunce from './wu/sunce.ts';
import zhouyu from './wu/zhouyu.ts';
import luxun from './wu/luxun.ts';
import lvmeng from './wu/lvmeng.ts';
import ganning from './wu/ganning.ts';
import taishici from './wu/taishici.ts';
import huanggai from './wu/huanggai.ts';
import sunshangxiang from './wu/sunshangxiang.ts';
import daqiao from './wu/daqiao.ts';
import zhoutai from './wu/zhoutai.ts';
import sunjian from './wu/sunjian.ts';
import xiaoqiao from './wu/xiaoqiao.ts';
import lusu from './wu/lusu.ts';
import chengpu from './wu/chengpu.ts';
import caocao from './wei/caocao.ts';
import caoren from './wei/caoren.ts';
import xiahoudun from './wei/xiahoudun.ts';
import xiahouyuan from './wei/xiahouyuan.ts';
import zhangliao from './wei/zhangliao.ts';
import dianwei from './wei/dianwei.ts';
import xuchu from './wei/xuchu.ts';
import xuhuang from './wei/xuhuang.ts';
import zhanghe from './wei/zhanghe.ts';
import yujin from './wei/yujin.ts';
import yuejin from './wei/yuejin.ts';
import simayi from './wei/simayi.ts';
import guojia from './wei/guojia.ts';
import xunyu from './wei/xunyu.ts';
import jiaxu from './wei/jiaxu.ts';
import zhenji from './wei/zhenji.ts';
import caohong from './wei/caohong.ts';
import zangba from './wei/zangba.ts';
import caozhen from './wei/caozhen.ts';
import caoxiu from './wei/caoxiu.ts';
import pangde from './wei/pangde.ts';
import wenpin from './wei/wenpin.ts';
import zhongyao from './wei/zhongyao.ts';
import liuye from './wei/liuye.ts';
import yangxiu from './wei/yangxiu.ts';
import guohuai from './wei/guohuai.ts';
import dengai from './wei/dengai.ts';
import caozhang from './wei/caozhang.ts';
import chengyu from './wei/chengyu.ts';
import xunyou from './wei/xunyou.ts';
import manchong from './wei/manchong.ts';
import lidian from './wei/lidian.ts';
import zhonghui from './wei/zhonghui.ts';
import caopi from './wei/caopi.ts';
// v0.1.3 新增（docs/HEROES-V013.md）
import lingtong from './wu/lingtong.ts';
import xusheng from './wu/xusheng.ts';
import dingfeng from './wu/dingfeng.ts';
import haozhao from './wei/haozhao.ts';
import xiahouba from './wei/xiahouba.ts';
import caochun from './wei/caochun.ts';
import guoxiu from './wei/guoxiu.ts';
import './units.ts';
import { applyTalents } from './talents.ts';

SG.HEROES = [
  // ================= 蜀 =================
  liubei,
  guanyu,
  zhangfei,
  zhaoyun,
  machao,
  huangzhong,
  zhugeliang,
  pangtong,
  weiyan,
  jiangwei,
  huangyueying,
  madai,
  xushu,
  mizhu,
  menghuo,
  zhurong,
  maliang,
  fazheng,
  zhoucang,
  chendao,
  // ================= 吳 =================
  sunquan,
  sunce,
  zhouyu,
  luxun,
  lvmeng,
  ganning,
  taishici,
  huanggai,
  sunshangxiang,
  daqiao,
  zhoutai,
  sunjian,
  xiaoqiao,
  lusu,
  chengpu,
  lingtong,
  xusheng,
  dingfeng,
  // ================= 魏 =================
  caocao,
  caoren,
  xiahoudun,
  xiahouyuan,
  zhangliao,
  dianwei,
  xuchu,
  xuhuang,
  zhanghe,
  yujin,
  yuejin,
  simayi,
  guojia,
  xunyu,
  jiaxu,
  zhenji,
  caohong,
  zangba,
  caozhen,
  caoxiu,
  pangde,
  wenpin,
  zhongyao,
  liuye,
  yangxiu,
  guohuai,
  dengai,
  caozhang,
  chengyu,
  xunyou,
  manchong,
  lidian,
  zhonghui,
  caopi,
  haozhao,
  xiahouba,
  caochun,
  guoxiu,
];
applyTalents(SG.HEROES); // 天賦：武將檔沒寫的，依 heroes/talents.ts 的名冊補上
SG.FEATURED = ['guanyu', 'zhaoyun', 'zhouyu', 'caocao', 'zhangliao', 'dianwei'];
